/* eslint-disable jsdoc/valid-types */

/**
 * @param {Node} node
 * @return {node is HTMLInputElement} Whether the node is an HTMLInputElement.
 */
export default function isHTMLInputElement(node) {
  /* eslint-enable jsdoc/valid-types */
  return (node === null || node === void 0 ? void 0 : node.nodeName) === 'INPUT';
}
//# sourceMappingURL=is-html-input-element.js.map